import * as Styles from "./Icon.styles";

export interface IconProps {
  name: string;
  size?: number;
}

export function Icon({ name, size = 1 }: IconProps) {
  return <Styles.Icon $size={size}>{name}</Styles.Icon>;
}
